/** The style bar's colours: the board's swatches and any colour, written to the fill, free text's words or an arrow's line. */
import { For, type JSX } from "solid-js";
import { useApp } from "../../../../app/context";
import { BOARD_COLOURS } from "../../../../state/board";
import { isHexColour, type Bar } from "./bar";

/** The colour field's value when the selection's colour is not one it can show. */
const PICK_FALLBACK = BOARD_COLOURS[0];

/** Swatches and a colour field. */
export function ColourTools(props: { bar: Bar }): JSX.Element {
  const { board } = useApp();
  const { colourKey, value, set } = props.bar;
  return (
    <div class="board-swatches">
      <For each={BOARD_COLOURS}>
        {(colour) => (
          <button
            type="button"
            class="swatch"
            data-style={colourKey()}
            data-value={colour}
            aria-label={`Colour ${colour}`}
            aria-pressed={value(colourKey()) === colour}
            style={{ background: colour }}
            onClick={() => set(colourKey(), colour)}
          />
        )}
      </For>
      <input
        type="color"
        class="board-colour-pick"
        id="board-colour"
        aria-label="Any colour"
        title="Any colour"
        value={isHexColour(value(colourKey())) ? value(colourKey()) : PICK_FALLBACK}
        onChange={(e) => void board.setStyle(colourKey(), e.currentTarget.value)}
      />
    </div>
  );
}
